import { useContext } from 'react'
import { AuthContext } from '@/auth/context'

// These checks are for what the interface shows, never for what the data
// layer allows. Every one of them is duplicated as a Row Level Security
// policy in supabase/migrations/20260818000400_rls.sql, and that copy is the
// one that counts. If you find yourself relying on a check here to keep data
// apart, the policy is missing.
export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider')
  return ctx
}
